module.exports = __webpack_public_path__ + "img/img_32389_0_306.2284f402.png";